import Transform from "@ember-data/serializer/transform";

export default class ThymicEpisodesTransform extends Transform {
  override deserialize(serialized) {
    serialized.forEach(thymicEpisode => {
      // Make sure occurredAt are of type Date and not string.
      // This is useful when passing the occurredAt in a DatePicker, which must have a Date and not a string.
      if (thymicEpisode.occurredAt) {
        thymicEpisode.occurredAt = new Date(thymicEpisode.occurredAt);
      }
    });
    return serialized;
  }

  override serialize(deserialized) {
    return deserialized;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "thymic-episodes": ThymicEpisodesTransform;
  }
}
